import type { FunctionComponent } from 'react';
import { createInstance, OptimizelyProvider } from '@optimizely/react-sdk';
import { useUserContext } from '@fff-web/fff-utilities';
import App from './App';

const optimizelyClientInstance = createInstance({ sdkKey: process.env.REACT_APP_OPTIMIZELY });

const AppWithOptimizely: FunctionComponent = () => {
  const { userInfo } = useUserContext();
  // userId should never be null since this is a logged in user
  const userId = userInfo?.user?.userId ?? 'anonymous';
  return (
    <OptimizelyProvider optimizely={optimizelyClientInstance} user={{ id: `${userId}` }}>
      <App />
    </OptimizelyProvider>
  );
};

export default AppWithOptimizely;
